/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PersonScreeningStatus {
    NEW = 'new',
    NOT_FOUND = 'notFound',
    PRE_SCREENING = 'preScreening',
}
